export default "__VITE_ASSET__gMWBAN$T__"